module.exports = __webpack_public_path__ + "staticfr/media/marcas (8).11beaaa2.jpg";